import { User } from "users";

export interface Monitoring {
  id: number;
  practiceReviewId: number;
  isPass: boolean | null;
  isReleased: boolean;
  sendToCommitteeOnFail: boolean;
  monitoringNotes: string | null;
  monitoringDate: string;
  isCompleted: boolean;
  completedByUser: User | null;
  completedDate: string | null;
  monitoringCompletedLetterId: number | null;
  letterGeneratedDate: string | null;
}

export interface MonitoringInput {
  id?: number;
  isPass?: boolean | null;
  sendToCommitteeOnFail?: boolean;
  monitoringNotes?: string | null;
  containerMonitoringNotes?: string | null;

  monitoringFrequencyInDays?: number;
  monitoringOccurrencesRemaining?: number;
}

export const FrequencyOptions = {
  Annually: { value: 365, label: "Annually" },
  Semiannually: { value: 180, label: "Semi-annually" },
  Quarterly: { value: 90, label: "Quarterly" },
  HardDeadline: { value: 0, label: "Hard Deadline" }
} as const;
